export const ADVANCED_SEARCH_DROPDOWN_CONSTANTS = {
    PLACEHOLDERS: {
        HCO: {
            id: 'hco',
            placeholder: 'Search Provider Measures By Name',
        },
        TIN: {
            id: 'tin',
            placeholder: 'Search by TIN',
        },
        GEO: {
            id: 'geo',
            placeholder: 'Search by city, state or ZIP',
        },
    },
    NO_OPTIONS: {
        DEFAULT: 'Please type at least 3 characters to start your search...',
        NOT_FOUND: 'No Results Found',
    },
    HIDDEN_ROUTES: [
        '/',
        '/myhome',
        '/psms',
        '/scorecard',
        '/operations',
        '/provider-briefing',
        '/provider-experience',
        '/pype-home',
        '/content-editor'
        // Add more routes where dropdown should be hidden
    ],
    HIDDEN_VIEWS: [
        'Contract Intelligence',
        'Operations',
        'Affordability Drivers',
        'Provider Negotiation Briefing',
        'Provider Experience',
        // Add more view names where dropdown should be hidden
    ],
};